module.exports = __webpack_public_path__ + "media/hph-25-12_commencement.28b2113f.webm";